import React from "react";
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";

class WithScrollTo extends React.Component {
  scrollTo = () => {
    const { targetRef, onScrollEnd, align } = this.props;
    if (targetRef) {
      const cb = scrollToComponent(targetRef, {
        align
      });
      cb.on("end", onScrollEnd);
    }
  };

  render() {
    return (
      <React.Fragment>{this.props.children(this.scrollTo)}</React.Fragment>
    );
  }
}

WithScrollTo.defaultProps = {
  align: "top",
  children: () => {},
  onScrollEnd: () => {}
};

WithScrollTo.propTypes = {
  align: PropTypes.oneOf(["top", "middle", "bottom"]),
  targetRef: PropTypes.object,
  onScrollEnd: PropTypes.func,
  children: PropTypes.func
};

export default WithScrollTo;



// WEBPACK FOOTER //
// ./src/components/common/WithScrollTo/WithScrollTo.js